// Sticky Add-to-Cart Fix
// Ensures the sticky add-to-cart button becomes visible when scrolling
document.addEventListener('DOMContentLoaded', function() {
  const stickyAtc = document.querySelector('[data-sticky-addtocart]');
  
  if (!stickyAtc) return;
  
  // Function to show sticky add-to-cart
  function showStickyAtc() {
    stickyAtc.classList.add('is--shown');
    stickyAtc.classList.remove('t4s-op-0', 't4s-pe-none');
    stickyAtc.style.opacity = '1';
    stickyAtc.style.pointerEvents = 'auto';
  }
  
  // Function to hide sticky add-to-cart
  function hideStickyAtc() {
    stickyAtc.classList.remove('is--shown');
    stickyAtc.classList.add('t4s-op-0', 't4s-pe-none');
  }
  
  // Check if we're on a product page
  const isProductPage = document.body.classList.contains('template-product') || 
                       document.querySelector('.t4s-product-form__variants');
  
  if (!isProductPage) return;
  
  // Find the main add-to-cart button position
  const mainAtcButton = document.querySelector('.t4s-product-form__submit, [data-atc-form]');
  
  if (!mainAtcButton) {
    // If no main button found, show sticky immediately
    showStickyAtc();
    return;
  }
  
  // Scroll handler
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const buttonRect = mainAtcButton.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Show sticky ATC when main button is not visible
    if (buttonRect.bottom < 0 || buttonRect.top > windowHeight) {
      showStickyAtc();
    } else {
      hideStickyAtc();
    }
  }
  
  // Initial check
  setTimeout(handleScroll, 500);
  
  // Add scroll listener with throttling
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
}); 